import BaseController from "../../controller/BaseController";
import { Button$PressEvent } from "sap/m/Button";
import { SearchField$LiveChangeEvent } from "sap/m/SearchField";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ListBinding from "sap/ui/model/ListBinding";
import Validator from "../../util/Validator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class TeamsController extends BaseController {

    public async onInit(): Promise<void> {

    }



    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    async onCreateTeam(): Promise<void> {

        this.updateModelProperty("/name", undefined);

        // Open the dialog for creating a team
        await this.openDialog("DialogCreateUpdateTeam");

    }

    async onSaveDialog(oEvent: any): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        /*
        // Get the current team
        const id = this.getModelProperty("/id");
        const departmentId = this.getModelProperty("/departmentId");*/
        const name = this.getModelProperty("/name");
        const status = this.getModelProperty("/status");

        var payload;

        // Create a new team    
        payload = await this.getClient().models.Team.create({

            name: name,
            status: status,
            departmentId: "faa080ec-8746-40ca-a695-f765fd19fe5e"
        })

        if (payload.errors) {
            console.error(payload.errors);
        }

        // Close the dialog
        this.destroyDialog("DialogCreateUpdateTeam");
    }

    onCloseDialog(): void {
        // Close the dialog
        this.destroyDialog("DialogCreateUpdateTeam");
    }

    onSearchFieldLiveChange(oEvent: SearchField$LiveChangeEvent): void {

        var oBinding = oEvent.getSource().getParent().getParent().getBinding("items") as ListBinding;

        var aFilters = [];
        var sQuery = oEvent.getSource().getValue();
        if (sQuery && sQuery.length > 0) {
            aFilters.push(new Filter("name", FilterOperator.Contains, sQuery));
            const oCombinedFilter = new Filter({ filters: aFilters, and: false });
            oBinding.filter(oCombinedFilter, "Application");
        } else {
            oBinding.filter([]);
        }

    }

    onNavigateTeam(oEvent: Button$PressEvent): void {

        // Get the path of the clicked team in the "allTeams" model
        const currentTeam = oEvent.getSource().getBindingContext("teams").getObject() as any;

        this.navTo("team", {
            id: currentTeam.id
        });
    }

}
